import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FormControl} from '@angular/forms';
import {merge, of, Subscription} from 'rxjs';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {Store} from '@ngxs/store';
import {AuthService} from '../../../auth.service';
import {catchError, debounceTime, map, startWith, switchMap, tap} from 'rxjs/operators';
import {Post} from 'jugacu-lib';
import {WhistlerAPIService} from '../../../whistler-api.service';


@Component({
    selector: 'app-posts',
    templateUrl: './posts.component.html',
    styleUrls: ['../../amaia/users/users.component.scss']
})
export class PostsComponent implements OnInit, AfterViewInit, OnDestroy {

    formControl = new FormControl();
    filter: string;

    displayedColumns: string[] = ['id', 'title', 'author', 'contents', 'comments', 'created_at', 'nsfw'];
    length: number;
    limit: number;
    dataSource = [];

    isLoadingResults = true;
    error = false;

    private sort$: Subscription;
    private dataSource$: Subscription;

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;

    constructor(
        private readonly store: Store,
        private readonly authService: AuthService,
        private readonly whistlerAPIService: WhistlerAPIService
    ) {

    }

    ngOnInit(): void {
    }

    async ngAfterViewInit(): Promise<void> {
        this.sort$ = this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

        const filterObs = this.formControl.valueChanges
            .pipe(
                debounceTime(500),
                tap(filter => {
                    this.paginator.pageIndex = 0;
                    this.filter = filter;
                })
            );

        this.dataSource$ = merge(this.sort.sortChange, this.paginator.page, filterObs)
            .pipe(
                startWith({}),
                switchMap(async () => {
                    this.isLoadingResults = true;
                    this.error = false;

                    return await this.whistlerAPIService.getFilteredPosts(this.paginator.pageIndex, this.sort.direction, this.filter);
                }),
                map(res => {
                    this.isLoadingResults = false;
                    this.length = res.data.length;
                    this.limit = res.data.limit;

                    return res.data.content;
                }),
                catchError(() => {
                    this.isLoadingResults = false;
                    this.error = true;

                    return of([]);
                })
            ).subscribe(data => this.dataSource = data);
    }

    ngOnDestroy(): void {
        this.sort$.unsubscribe();
        this.dataSource$.unsubscribe();
    }

    goToIdc(post: Post) {
        window.open(`https://idc.jugacu.es/post/${post.id}`);
    }
}
